import { Tab, tabNavAtom, selectedTabAtom } from "../state";
import { getSectionsForTab } from "../sectionConfig";
import { useRouter } from "@/utils/router";
import clsx from "clsx";
import { motion } from "framer-motion";
import { useAtom } from "jotai";

export function TabNavigation() {
    const [selectedTab, setSelectedTab] = useAtom(tabNavAtom);
    const [, setSelectedSection] = useAtom(selectedTabAtom);
    const router = useRouter();

    const handleTabChange = (tab: Tab) => {
        setSelectedTab(tab);

        const sectionsForTab = getSectionsForTab(tab);
        const firstSection = sectionsForTab[0]?.id;

        if (firstSection) {
            setSelectedSection(firstSection);
            router.updateSearch("section", firstSection);
        }
    };

    return (
        <nav>
            <ul className="flex w-fit gap-[10px]">
                {Object.values(Tab).map((tab) => (
                    <li
                        key={tab}
                        onClick={() => {
                            if (tab === Tab.FULL_MEMO)
                                handleTabChange(tab as Tab);
                        }}
                        className={clsx("cursor-pointer")}
                    >
                        <p
                            className={clsx(
                                "body-s px-3 py-1.5",
                                tab === selectedTab
                                    ? "text-color hover:text-color"
                                    : "cursor-default text-gray-400 hover:text-gray-400",
                            )}
                        >
                            {tab}
                        </p>
                        {tab === selectedTab ? (
                            <motion.div
                                className="h-[3px] bg-brand-500 underline"
                                layoutId="underline"
                            />
                        ) : null}
                    </li>
                ))}
            </ul>
        </nav>
    );
}
